// AUTOGENERATED BY FUNCTION genubamodel.js
export interface IdentityProfileCommand extends CommandBase {
    data?: IdentityProfile;
}

export interface GroupPermissionCommand extends CommandBase {
    data?: GroupPermission;
}

export interface PermissionOptionsCommand extends CommandBase {
    data?: PermissionOptions;
}

export interface TokenCommand extends CommandBase {
    data?: Token;
}

export interface UserPermissionCommand extends CommandBase {
    data?: UserPermission;
}

export interface Devices {
    deviceKey?: string;
    rememberDate?: string;
    needsReset?: boolean;
}

export interface GroupPermission extends EntityBase {
    allowedActions?: AllowedActions;
    app?: string;
}

export interface IdentityProfile extends EntityBase {
    identityId?: string;
    profileType?: string;
    profileId?: string;
    idpGroup?: string;
    selectedClientId?: string;
    selectedAgencyId?: string;
    selectedDivisionId?: string;
    tpaPartner?: string;
    devices?: Devices[];
}

export interface UserPermission extends EntityBase {
    sub?: string;
    allowedActions?: string;
    data?: string;
}

export interface Permission {
    name?: string;
    type?: string;
    path?: string;
    selected?: boolean;
}

export interface PermissionOptions extends EntityBase {
    sections?: PermissionSection[];
}

export interface PermissionSection {
    title?: string;
    id?: string;
    selectAll?: boolean;
    permissionSubjects?: PermissionSubject[];
}

export interface PermissionSubject {
    title?: string;
    selected?: boolean;
    permissions?: Permission[];
}

export interface Token extends EntityBase {
    token?: string;
    srtPlanId?: string;
}

export interface AuthenticationAssociation {
    identityProvider?: string;
    idpUsername?: string;
    idpSub?: string;
    idpEmail?: string;
    appClientId?: string;
    profileType?: string;
    profileId?: string;
    firstObserved?: string;
    lastObserved?: string;
}

export interface AllowedActions {
    excludedClients: ExcludedClient[];
    sections: Section[];
    allowedFundingTransferTypes: FundsTransferType[];
}

export interface ExcludedClient {
    id: string;
    name?: string;
}

export interface Section {
    id?: string;
    queryPaths: string[];
    commandPaths?: CommandPath[];
}

export interface CommandPath {
    commands: string[];
    path: string;
}

export interface Error {
    message?: string;
    fields?: object;
}

export interface GroupCriteria {
    key?: string;
    value?: string;
    matchType?: MatchType;
    chainType?: ChainType;
}

export interface Criteria {
    key?: string;
    value?: string;
    matchType?: MatchType;
    chainType?: ChainType;
    groupCriteria?: GroupCriteria[];
}

export interface QueryCriteria {
    index?: string;
    searchCriteria: SearchCriteria;
    filterCriteria?: SearchCriteria;
    projectionExpression?: string;
}

export type SearchCriteria = Criteria[];

export type CognitoAttributes = CognitoAttribute[];

export interface CognitoAttribute {
    Name: string;
    Value: string;
}

export type GroupPermissions = GroupPermission[];

export type IdentityProfiles = IdentityProfile[];

export type UserPermissions = UserPermission[];

export interface CommandBase {
    id?: string;
    eventCorrelationId?: string;
    jobId?: string;
    producerId?: string;
    sequenceId?: number;
    version?: number;
    type?: string;
    created?: string;
    createdBy?: string;
    createdById?: string;
}

export interface EntityBase {
    id?: string;
    parentId?: string;
    parentType?: ParentType;
    version?: number;
    created?: string;
    createdBy?: string;
    createdById?: string;
    updated?: string;
    updatedBy?: string;
    updatedById?: string;
    currentState?: string;
    lastTransition?: string;
    externalWorkflowId?: string;
    eventNotes?: string;
    transactionLockId?: string;
}

export interface ProcessCognitoProfileCommand extends CommandBase {
    data?: ProcessCognitoProfile;
}

export interface ProcessCognitoProfile extends EntityBase {
    attributesToUpdate?: CognitoAttributes;
    profileType?: string;
    profileAction?: CognitoProfileAction;
}

export enum UserPermissionCommandType {
    StartToActive = 'StartToActive',
    ActiveToActive = 'ActiveToActive',
    ActiveToRemoved = 'ActiveToRemoved',
}

export enum IdentityProfileCommandType {
    StartToActive = 'StartToActive',
    ActiveToActive = 'ActiveToActive',
    ActiveToRemoved = 'ActiveToRemoved',
}

export enum GroupPermissionCommandType {
    StartToActive = 'StartToActive',
    ActiveToActive = 'ActiveToActive',
    ActiveToRemoved = 'ActiveToRemoved',
}

export enum PermissionOptionsCommandType {
    StartToActive = 'StartToActive',
    ActiveToActive = 'ActiveToActive',
    ActiveToRemoved = 'ActiveToRemoved',
}

export enum CognitoProfileCommandType {
    StartToProcessing = 'StartToProcessing',
}

export enum FundsTransferType {
    ACHConvenienceFeeSweepAutomated = 'ACHConvenienceFeeSweepAutomated',
    ACHConvenienceFeeSweepManual = 'ACHConvenienceFeeSweepManual',
    BenefitAccountAdjustment = 'BenefitAccountAdjustment',
    BenefitAccountCardFunding = 'BenefitAccountCardFunding',
    BenefitAccountToMyCashWithoutRequest = 'BenefitAccountToMyCashWithoutRequest',
    BureauBenefitAccountCardFunding = 'BureauBenefitAccountCardFunding',
    BureauContributionDrawAutomated = 'BureauContributionDrawAutomated',
    BureauContributionDrawManual = 'BureauContributionDrawManual',
    BureauDisbursementDrawManual = 'BureauDisbursementDrawManual',
    BureauTransferFromSecondaryBureauAutomated = 'BureauTransferFromSecondaryBureauAutomated',
    BureauTransferFromSecondaryBureauManual = 'BureauTransferFromSecondaryBureauManual',
    BureauTransferToSecondaryBureauAutomated = 'BureauTransferToSecondaryBureauAutomated',
    BureauTransferToSecondaryBureauManual = 'BureauTransferToSecondaryBureauManual',
    CABBalanceAdjustment = 'CABBalanceAdjustment',
    CABDisbursementToClient = 'CABDisbursementToClient',
    CDAFDisbursementToClient = 'CDAFDisbursementToClient',
    CDAFToBenefitAccount = 'CDAFToBenefitAccount',
    CardConvenienceFeeSweepAutomated = 'CardConvenienceFeeSweepAutomated',
    CardConvenienceFeeSweepManual = 'CardConvenienceFeeSweepManual',
    CharityAdjustment = 'CharityAdjustment',
    ClientCABFunding = 'ClientCABFunding',
    ClientCABFundingToCDAF = 'ClientCABFundingToCDAF',
    ClientCABToCDAF = 'ClientCABToCDAF',
    ClientFeeAssessmentSweepAutomated = 'ClientFeeAssessmentSweepAutomated',
    ClientFeeAssessmentSweepManual = 'ClientFeeAssessmentSweepManual',
    ClientPaymentSourceToBenefitAccount = 'ClientPaymentSourceToBenefitAccount',
    ClientPaymentSourceToInvestmentBenefitAccount = 'ClientPaymentSourceToInvestmentBenefitAccount',
    ClientRemittanceAccountAdjustment = 'ClientRemittanceAccountAdjustment',
    CustodialInvestmentRolloverToBenefitAccount = 'CustodialInvestmentRolloverToBenefitAccount',
    DesignatedHoldingAccountAdjustment = 'DesignatedHoldingAccountAdjustment',
    DonationDisbursementToCharity = 'DonationDisbursementToCharity',
    FundedConversionRolloverToBenefitAccount = 'FundedConversionRolloverToBenefitAccount',
    GivebackAccountToCharity = 'GivebackAccountToCharity',
    HSAOrphanFeeSweepAutomated = 'HSAOrphanFeeSweepAutomated',
    HSAOrphanFeeSweepManual = 'HSAOrphanFeeSweepManual',
    IndividualDonorAdvisedFundToMyCashRefund = 'IndividualDonorAdvisedFundToMyCashRefund',
    IndividualGivingAccountToMyCashRefund = 'IndividualGivingAccountToMyCashRefund',
    InvestmentBenefitAccountAdjustment = 'InvestmentBenefitAccountAdjustment',
    InvestmentInterestToBenefitAccount = 'InvestmentInterestToBenefitAccount',
    MyCashAdjustment = 'MyCashAdjustment',
    MyCashDesignatedHoldingAccountAdjustment = 'MyCashDesignatedHoldingAccountAdjustment',
    MyCashFeeSweepAutomated = 'MyCashFeeSweepAutomated',
    MyCashFeeSweepManual = 'MyCashFeeSweepManual',
    MyCashToBenefitAccount = 'MyCashToBenefitAccount',
    MyCashToBenefitAccountCardRefund = 'MyCashToBenefitAccountCardRefund',
    MyCashToBureauBenefitAccount = 'MyCashToBureauBenefitAccount',
    MyCashToPaymentSource = 'MyCashToPaymentSource',
    MyCashUndesignatedHoldingAccountAdjustment = 'MyCashUndesignatedHoldingAccountAdjustment',
    ParticipantACHToBenefitAccount = 'ParticipantACHToBenefitAccount',
    ParticipantACHToInvestmentBenefitAccount = 'ParticipantACHToInvestmentBenefitAccount',
    ParticipantCheckToBenefitAccount = 'ParticipantCheckToBenefitAccount',
    ParticipantCheckToInvestmentBenefitAccount = 'ParticipantCheckToInvestmentBenefitAccount',
    ParticipantInvestmentRolloverToBenefitAccount = 'ParticipantInvestmentRolloverToBenefitAccount',
    ParticipantPaymentSourceToBenefitAccountRefund = 'ParticipantPaymentSourceToBenefitAccountRefund',
    ParticipantPaymentSourceToMyCash = 'ParticipantPaymentSourceToMyCash',
    PayeeRemittanceAccountAdjustment = 'PayeeRemittanceAccountAdjustment',
    PaymentPlanAdminFeeSweepAutomated = 'PaymentPlanAdminFeeSweepAutomated',
    PaymentPlanAdminFeeSweepManual = 'PaymentPlanAdminFeeSweepManual',
    PaymentPlanAdminSurchargeFeeSweepAutomated = 'PaymentPlanAdminSurchargeFeeSweepAutomated',
    PaymentPlanAdminSurchargeFeeSweepManual = 'PaymentPlanAdminSurchargeFeeSweepManual',
    PaymentPlanNSFFeeSweepAutomated = 'PaymentPlanNSFFeeSweepAutomated',
    PaymentPlanNSFFeeSweepManual = 'PaymentPlanNSFFeeSweepManual',
    PaymentPlanToPayee = 'PaymentPlanToPayee',
    PptACHToPptHoldingAccount = 'PptACHToPptHoldingAccount',
    PptCardToPptHoldingAccount = 'PptCardToPptHoldingAccount',
    PptCheckToPptHoldingAccount = 'PptCheckToPptHoldingAccount',
    PptDesignatedHoldingAccountInactivation = 'PptDesignatedHoldingAccountInactivation',
    PptDesignatedHoldingAccountToPptHoldingAccount = 'PptDesignatedHoldingAccountToPptHoldingAccount',
    PptUndesignatedHoldingAccountInactivation = 'PptUndesignatedHoldingAccountInactivation',
    PptUndesignatedHoldingAccountToPptHoldingAccount = 'PptUndesignatedHoldingAccountToPptHoldingAccount',
    PptUndesignatedHoldingAccountToPptHoldingAccountPending = 'PptUndesignatedHoldingAccountToPptHoldingAccountPending',
    RemittanceDistributionToClient = 'RemittanceDistributionToClient',
    RemittanceDistributionToPayee = 'RemittanceDistributionToPayee',
    RemittanceStagingAccountAdjustment = 'RemittanceStagingAccountAdjustment',
    SweepBinPayeeAccount = 'SweepBinPayeeAccount',
    SweepPaymentProcessorBinAccount = 'SweepPaymentProcessorBinAccount',
    TakeoverBenefitAccountToMyCashWithoutRequest = 'TakeoverBenefitAccountToMyCashWithoutRequest',
    UndesignatedHoldingAccountAdjustment = 'UndesignatedHoldingAccountAdjustment',
    UnfundedBenefitAccountAdjustment = 'UnfundedBenefitAccountAdjustment',
    UnfundedConversionRolloverToBenefitAccount = 'UnfundedConversionRolloverToBenefitAccount',
}

export enum TokenCommandType {
    authorize = 'authorize',
    create = 'create',
    inject = 'inject',
    refresh = 'refresh',
}

export enum CognitoEventType {
    InitiateAuth = 'InitiateAuth',
    RespondToAuthChallenge = 'RespondToAuthChallenge',
    ConfirmForgotPassword = 'ConfirmForgotPassword',
    UpdateDeviceStatus = 'UpdateDeviceStatus',
    ChangePassword = 'ChangePassword',
    SetUserMFAPreference = 'SetUserMFAPreference',
    ConfirmDevice = 'ConfirmDevice',
    ForgotPassword = 'ForgotPassword',
}

export enum MatchType {
    CONTAINS = 'CONTAINS',
    EXACT = 'EXACT',
    NOT = 'NOT',
    IN = 'IN',
    NOT_IN = 'NOT_IN',
    NOT_CONTAINS = 'NOT_CONTAINS',
    STARTS_WITH = 'STARTS_WITH',
    NOT_STARTS_WITH = 'NOT_STARTS_WITH',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
    IS_NULL = 'IS_NULL',
}

export enum ChainType {
    AND = 'AND',
    OR = 'OR',
}

export enum PermissionLevel {
    One = 'One',
    Two = 'Two',
    Three = 'Three',
}

export enum CognitoProfileAction {
    UpdateAttributes = 'UpdateAttributes',
    ConfirmSignUp = 'ConfirmSignUp',
}

export enum ParentType {
    INSTANCE = 'INSTANCE',
    CLIENT = 'CLIENT',
    INDIVIDUAL = 'INDIVIDUAL',
    REQUEST = 'REQUEST',
}
